<template>
  <div class="detail-dialog">
    <el-dialog
      title="详情"
      :visible.sync="dialogVisible"
      :lock-scroll="true"
       width="600px"
      :before-close="handleClose"
    >
      <el-form ref="info-form" :model="formLine" label-width="110px" v-loading="loading">
        <el-form-item label="申请区域:" prop="area">
          <div>{{address}}</div>
        </el-form-item>
        <el-form-item label="申请客户类型:" prop="customerType">
          <div>{{formLine.customerName || ''}}</div>
        </el-form-item>
        <el-form-item label="申请商品类型:" prop="goodsType">
          <div>{{formLine.goodsType || ''}}</div>
        </el-form-item>
        <el-form-item label="身份信息" prop="identityImage">
          <el-image
            v-for="(url, index) in formLine.identityImage"
            :key="index"
            style="width: 100px; height: 100px"
            :src="url"
            :preview-src-list="formLine.identityImage"
            :initial-index="currentImgIndx"
            fit="contain"
            @click="handlePreviewImg(index)"
            class="id-image"
          >
          </el-image>
        </el-form-item>
        <el-form-item label="个人简介" prop="individualResume">
          <el-input
            v-model="formLine.individualResume"
            readonly
            placeholder="个人简介"
            type="textarea"
            rows="3"
          ></el-input>
        </el-form-item>
      </el-form>
      <template #footer>
        <div class="footer-action-row">
          <el-button v-if="formLine.auditStatus == 'AWAIT_AUDIT'" type="primary" @click="handlerAudit">审核通过</el-button>
          <el-button  v-if="formLine.auditStatus == 'AWAIT_AUDIT'" type="primary" @click="handlerReject">驳回</el-button>
          <el-button type="default" @click="handleClose">返回</el-button>
        </div>
      </template>
    </el-dialog>
  </div>
</template>
<script>
import { querySalesUserByPhoneAsName, getCustomerAndGoodsType } from '@/api/externalSalesRule/index'
/**  详情 */
export default {
  name: "",
  data() {
    return {
      dialogVisible: false,
      formLine: {},
      srcList: [],
      currentImgIndx: 0,
      loading: false,
      typeOptions:[] // 商品类型 和 客户类型
    }
  },
  computed: {
    address() {
      return this.formLine
        ? `${this.formLine.applicationAreaProvinceName || ""}${
            this.formLine.applicationAreaCityName || ""
          }${this.formLine.applicationAreaName || ""}`
        : "";
    },
  },
  methods: {
    init(value) {
      console.log("init====", value);
      this.$nextTick(async () => {
        this.dialogVisible = true;
        this.getDetailInfo(value)
      })
    },
    // 获取详情
    getDetailInfo(params){
      if(!params) return
      this.loading = true
      let { contactInformation, salesUserName } = params
      querySalesUserByPhoneAsName({
        contactInformation,
        salesUserName
      }).then(res => {
        console.log('querySalesUserByPhoneAsName=====>', res);
        res.identityImage
        if(res.identityImage){
          res.identityImage = res.identityImage.split(',')
        }
        this.formLine = res ? {...res} : {}
      }).finally(() => this.loading = false)
    },
    // 身份信息预览
    handlePreviewImg(index){
      this.currentImgIndx = index
    },
    // 审核通过
    handlerAudit() {
      this.$emit("updateStatus", "pass");
    },
    // 驳回
    handlerReject() {
      this.$emit("updateStatus", "reject");
    },
    // 返回
    handleClose() {
      this.close()
      this.$emit("close");
    },
    close(){
      this.dialogVisible = false;
    }
  },
};
</script>
<style lang="scss" scoped>
.footer-action-row {
  display: flex;
  justify-content: flex-end;
  align-items: center;
}
.id-image {
  margin-right: 15px;
}
</style>